import { each } from 'lodash';

export default {
  sport: (state) => {
    const idSport = state.selectedId.sport;
    return state.sports.find(sport => sport.id === idSport);
  },
  tournament: (state) => {
    const idSport = state.selectedId.sport;
    const idTournament = state.selectedId.tournament;
    const tournaments = state.tournaments[idSport];
    return tournaments
      ? tournaments.find(t => t.id === idTournament) : undefined;
  },
  tournamentBetTemplates: (state) => {
    const idSport = state.selectedId.sport;
    return state.tournamentBetTemplates[idSport] || [];
  },
  bet: (state) => {
    const idTournament = state.selectedId.tournament;
    const idBet = state.selectedId.bet;
    const bets = state.bets[idTournament];
    return bets
      ? bets.find(bet => bet.id === idBet) : undefined;
  },
  tournaments: (state) => {
    const idSport = state.selectedId.sport;
    return state.tournaments[idSport];
  },
  bets: (state) => {
    const idTournament = state.selectedId.tournament;
    return state.bets[idTournament];
  },
  matches: (state) => {
    const idTournament = state.selectedId.tournament;
    const idBet = state.selectedId.bet;
    return state.matches[idTournament]
      ? state.matches[idTournament][idBet] : undefined;
  },
  selection: state => (type) => {
    let values = [];
    switch (type) {
      case 'sport':
        values = state.sports.map(sport => ({ id: sport.id, active: sport.active }));
        break;
      case 'tournament':
        Object.keys(state.tournaments).forEach((idSport) => {
          const tournaments = state.tournaments[idSport];
          tournaments.forEach(tournament => values.push({
            active: tournament.active,
            id: tournament.id,
            betTemplate: Object.keys(tournament.betTemplate).length > 0
              ? tournament.betTemplate : null,
          }));
        });
        break;
      case 'bet':
        Object.keys(state.bets).forEach((idTournament) => {
          const bets = state.bets[idTournament];
          bets.forEach(bet => values.push({
            active: bet.active,
            id: bet.id,
            id_tournament: idTournament,
          }));
        });
        break;
      case 'match':
        each(state.matches, (bets) => {
          Object.keys(bets).forEach((idBet) => {
            const matches = bets[idBet];
            matches.forEach(match => values.push({
              active: match.active,
              id: match.id,
              id_bet: idBet,
            }));
          });
        });
        break;
      default:
    }

    return values;
  },
};
